import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { toVw, toVwTablet, toVwMobile } from '../../../utils/styles';
import mq from '@/utils/media-queries';

const Styled = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const Col = styled.div`
  box-sizing: border-box;
  width: 36.7%;
  padding-right: ${toVw(106)};

  &:nth-child(3n) {
    width: 26.6%;
    padding-right: 0;
  }

  ${mq.tablet(css`
    && {
      width: 50%;
      padding-right: ${toVwTablet(30)};
    }
  `)};

  ${mq.mobile(css`
    && {
      padding-right: ${toVwMobile(30)};
    }
  `)};
`;

const AboutCols = ({ children, className }) => <Styled className={className}>{children}</Styled>;

AboutCols.propTypes = {
  className: PropTypes.string,
};

AboutCols.Col = ({ children }) => <Col>{children}</Col>;
AboutCols.Col.displayName = 'Col';

export default AboutCols;



// WEBPACK FOOTER //
// ./src/scenes/About/components/AboutCols.js